import { useSubscription } from "@apollo/client";
import { SITE_PROGRESS_UPDATED } from "../created-site.queries";
import {
  SiteProgressUpdatedSubscription,
  SiteProgressUpdatedSubscriptionVariables,
} from "../../../__generated__/SiteProgressUpdatedSubscription";

export const useSiteProgress = (
  variables: SiteProgressUpdatedSubscriptionVariables,
  skip: boolean
) => {
  return useSubscription<
    SiteProgressUpdatedSubscription,
    SiteProgressUpdatedSubscriptionVariables
  >(SITE_PROGRESS_UPDATED, {
    variables,
    skip,
  });
};
